
export enum SelectedCustomerView {
  List,
  Info,
  Messaging,
  BidNav,
  AddNewCustomer  
}

export enum MessagingView {
  Log,
  Add,
  Email
}

export enum SelectedMessageType {
  InboundCall = 1,
  OutboundCall = 2,
  GeneralComment = 3,
  EmailSent = 4
}

export enum ButtonBarButton {
  BidNav,
  Messaging,
  CustomerInfo,
  Close,
  AddNewCustomer
}

export enum CustomerListViewFilter {
  ActiveCustomers,
  InactiveCustomers,
  AllCustomers
}

export enum CustomerInfoView {
  CustomerInfo,
  PaymentInfo,
  Profiles,
  BiddingPlans,
  SubscriptionInfo,
  PilotInfo,
  AwardReport
}

export enum BillingButtonBarButton {
  CreateCharge,
  CreateCredit,
  CreatePromotion,
  ProcessPaymets,
  TransactionHistory
}

export enum AdminUserRoleType {
  Admin = "1",
  QC = "2",
  DataImport = "3",
  GroupEmail = "4",
  AwardEmail = "5",
  Billing = "6",
  DeleteCustomer = "7"
}

export enum ImportDocumentType {
  trip_change = "trip-change",
  award_report = "award-report",
  bid_pack = "bid-pack",
  credit_range = "credit-range"
}